import Administration from '../Administration/Administration';
import Registers from "../Administration/Registers";
import Panel from '../../components/views/panel/Home';
import PanelHome from '../../components/views/panel/partials/PanelHome';
import NotFound from '../../components/views/panel/partials/NotFound';
const Profile = _ => import(/* webpackChunkName: "js/split/Profile", webpackPreload: true */ '@/components/partials/Profile');

export default {
    path: '/',
    meta:{
        auth: true,
    },
    component: Panel,
    children: [
        {
            path: '',
            component: PanelHome,
            meta: {
                auth: true,
            }
        },
        {
            path: '/perfil',
            component: Profile,
            meta: {
                auth: true,
            }
        },
        {...Administration},
        {...Registers},
        {
            path: '*',
            component: NotFound,
            meta:{
                auth: true
            }
        }
    ],
    beforeEnter: (to,from,next) => {
        if(sessionStorage.getItem('sipac_token')){
            next();
        }else{
            next('/login');
            setTimeout(() => {
                location.reload();
            },1000)
        }
    }

}
